/*
 *   Copyright (c) 2021
 *   All rights reserved.
 */
import { lazy } from 'react';
import { IRouteProps } from 'src/modules';

export const route = '/metaverse';

const MetaverseNFT: IRouteProps = {
    path: route,
    exact: true,
    component: lazy(() => import('src/modules/MintNFT/components/MetaverseNFT')),
    name: 'MetaverseNFT',
};

export default MetaverseNFT;
